<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <a-descriptions bordered :column="2" size="small" title="基础信息">
        <a-descriptions-item :span="2" label="商品编号">
          {{ goodsInfo.id }}
        </a-descriptions-item>
        <a-descriptions-item :span="2" label="商品名称">
          {{ goodsInfo.goodsName }}
        </a-descriptions-item>
        <a-descriptions-item :span="2" label="商品主图">
          <img v-if="goodsInfo.picture" :src="goodsInfo.picture" style="width: 100px; height: 100px; object-fit: cover;" alt="商品主图" />
          <span v-else>无</span>
        </a-descriptions-item>
        <a-descriptions-item label="商品分类">
          {{ getCategoryName(goodsInfo.categoryId) }}
        </a-descriptions-item>
        <a-descriptions-item label="品牌">
          {{ getBrandName(goodsInfo.brandId) }}
        </a-descriptions-item>
        <a-descriptions-item label="商品状态">
          <custom-dict-tag :options="customDict.GoodsOnOffEnum" :value="goodsInfo.status"/>
        </a-descriptions-item>
        <a-descriptions-item label="是否推荐">
          <custom-dict-tag :options="customDict.TFEnum" :value="goodsInfo.isRecommend"/>
        </a-descriptions-item>
        <a-descriptions-item label="商品价">
          ¥{{ goodsInfo.price }}
        </a-descriptions-item>
        <a-descriptions-item label="成本价">
          ¥{{ goodsInfo.costPrice }}
        </a-descriptions-item>
        <a-descriptions-item label="库存">
          {{ goodsInfo.stock }}
        </a-descriptions-item>
        <a-descriptions-item label="销量">
          {{ goodsInfo.sales }}
        </a-descriptions-item>
        <a-descriptions-item label="店铺名称">
          {{ goodsInfo.shopName || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ parseTime(goodsInfo.createTime) }}
        </a-descriptions-item>
        <a-descriptions-item label="更新时间">
          {{ parseTime(goodsInfo.updateTime) }}
        </a-descriptions-item>
      </a-descriptions>

      <!-- 商品详情富文本 -->


      <!-- SKU列表 -->
      <div v-if="goodsInfo.skuList && goodsInfo.skuList.length > 0" style="margin-top: 20px;">
        <h4 style="margin-bottom: 16px;">SKU列表</h4>
        <a-table
          :columns="skuColumns"
          :data-source="goodsInfo.skuList"
          :pagination="false"
          rowKey="id"
          bordered
          size="small"
        >
          <span slot="picture" slot-scope="text, record">
            <img v-if="record.picture" :src="record.picture" style="width: 50px; height: 50px; object-fit: cover;" alt="SKU图片" />
            <span v-else>-</span>
          </span>
          <span slot="specValueIds" slot-scope="text">
            {{ text || '-' }}
          </span>
        </a-table>
      </div>
      <div v-if="goodsInfo.description" style="margin-top: 20px;">
        <h4 style="margin-bottom: 16px;">商品详情</h4>
        <div v-html="goodsInfo.description" class="detail-content"></div>
      </div>
      <!-- 规格列表 -->
<!--      <div v-if="goodsInfo.specList && goodsInfo.specList.length > 0" style="margin-top: 20px;">-->
<!--        <h4 style="margin-bottom: 16px;">规格列表</h4>-->
<!--        <a-table-->
<!--          :columns="specColumns"-->
<!--          :data-source="goodsInfo.specList"-->
<!--          :pagination="false"-->
<!--          rowKey="id"-->
<!--          bordered-->
<!--          size="small"-->
<!--        >-->
<!--          <span slot="values" slot-scope="text, record">-->
<!--            {{ getSpecValueNames(record.values) }}-->
<!--          </span>-->
<!--        </a-table>-->
<!--      </div>-->
    </a-spin>
  </a-modal>
</template>

<script>
import { getGoods } from '@/api/goods/goods'
import { listCategoryPlat } from "@/api/goods/category"
import { allBrand } from "@/api/goods/brand"
import CustomDictTag from "@/components/DictCustomTag"
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'GoodsDetail',
  components: {
    CustomDictTag
  },
  data() {
    return {
      title: '商品详情',
      visible: false,
      loading: false,
      goodsInfo: {},
      categoryList: [],
      brandList: [],
      // SKU表格列
      skuColumns: [
        // {
        //   title: 'SKU ID',
        //   dataIndex: 'id',
        //   width: 80
        // },
        {
          title: '商品条码',
          dataIndex: 'barcode',
          width: 120,
          customRender: (text) => text || '-'
        },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 150
        },

        // {
        //   title: '规格值',
        //   dataIndex: 'specValueIds',
        //   width: 150,
        //   scopedSlots: { customRender: 'specValueIds' }
        // },
        {
          title: 'SKU图片',
          dataIndex: 'picture',
          width: 80,
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '价格',
          dataIndex: 'price',
          width: 80,
          customRender: (text) => `¥${text}`
        },
        {
          title: '会员价',
          dataIndex: 'memberPrice',
          width: 80,
          customRender: (text) => text ? `¥${text}` : '-'
        },
        {
          title: '秒杀价',
          dataIndex: 'seckillPrice',
          width: 80,
          customRender: (text) => text ? `¥${text}` : '-'
        },
        {
          title: '团购价',
          dataIndex: 'groupPrice',
          width: 80,
          customRender: (text) => text ? `¥${text}` : '-'
        },
        {
          title: '库存',
          dataIndex: 'stock',
          width: 80
        },
        {
          title: '门店销售价',
          dataIndex: 'salePrice',
          width: 100,
          customRender: (text) => text ? `¥${text}` : '-'
        }
      ],
      // 规格表格列
      specColumns: [
        {
          title: '规格ID',
          dataIndex: 'id',
          width: 80
        },
        {
          title: '规格名称',
          dataIndex: 'specName',
          width: 120
        },
        {
          title: '规格值',
          dataIndex: 'values',
          scopedSlots: { customRender: 'values' }
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: 80
        }
      ]
    }
  },
  computed: {
    customDict() {
      return this.$store.getters.customDict
    }
  },
  methods: {
    parseTime,
    // 打开详情
    open(id) {
      this.visible = true
      this.loading = true
      this.getGoodsDetail(id)
      this.getCategoryList()
      this.getBrandList()
    },
    // 获取商品详情
    getGoodsDetail(id) {
      getGoods({ id: id }).then(response => {
        this.goodsInfo = response.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取分类列表
    getCategoryList() {
      listCategoryPlat().then(response => {
        this.categoryList = response.data
      })
    },
    // 获取品牌列表
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    // 获取分类名称
    getCategoryName(id) {
      if (!id) return '-'
      const category = this.categoryList.find(e => e.id === id)
      return category ? category.categoryName : '-'
    },
    // 获取品牌名称
    getBrandName(id) {
      if (!id) return '-'
      const brand = this.brandList.find(e => e.id === id)
      return brand ? brand.name : '-'
    },
    // 获取规格值名称
    getSpecValueNames(values) {
      if (!values || !Array.isArray(values)) return '-'
      return values.map(v => v.specValueName).join(', ')
    },
    // 关闭
    handleCancel() {
      this.visible = false
      this.goodsInfo = {}
    }
  }
}
</script>

<style scoped>
.detail-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  background-color: #fafafa;
  border-radius: 4px;
}
.detail-content >>> * {
  max-width: 100% !important;
  box-sizing: border-box;
}
.detail-content >>> img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px 0;
}
.detail-content >>> table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}
.detail-content >>> table td,
.detail-content >>> table th {
  border: 1px solid #ddd;
  padding: 8px;
}
.detail-content >>> p {
  margin: 8px 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.detail-content >>> div {
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
